import React, { useEffect, useState } from "react";
import "./right.css";
import { FiEdit } from "react-icons/fi";
import { calendarTime } from "../../assets/svgIcons";
import { Link } from "react-router-dom";
import PopUp from "../../components/popup";
import { useNavigate } from "react-router-dom";

import "./style.css";
import { EnglishIcon, KSA, Phone, whatsApp } from "../../assets/svgIcons/index";
import IconWithText from "../../components/iconWithText";
import UseGeneral from "../../hooks/useGeneral";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import toast from "react-hot-toast";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
export const Right = ({ orderData }) => {
  //
  const navigate = useNavigate();
  const [cancelOrder, setCancelOrder] = useState(false);
  const [returnPolicyOpen, setReturnPolicyOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const { language, changeLanguage } = UseGeneral();
  const [cancleLoading, setCancleLoading] = useState(false);
  const [returnPolicies, setReturnPolicies] = useState([]);
  const siteData = useSelector((state) => state?.site?.siteData);
  console.log(siteData);
  const [reasons, setReasons] = useState([]);
  const [comment, setComment] = useState("");
  const [cancel_reson, setcancel_reson] = useState("");
  const handleCancelOrder = () => {
    // navigate("/cancel-order");
    setCancleLoading(true);
    const data = {
      comment,
      cancel_reson,
    };
    // ;
    Axios({
      url: BASE_URL + `orders/cancle_order/${orderData.id}`,
      method: "post",
      data,
    })
      .then((res) => {
        if (res.status == "success") {
          navigate("/cancel-order", { state: { orderData }, replace: true });
        } else if (res.status == "faild") {
          toast.error(res.message);
        } else {
          toast.error(language == "ar" ? "حدث خطأ ما" : "Something Error");
        }
        //
      })
      .finally(() => {
        setCancleLoading(false);
      });
  };
  const getReturns = () => {
    Axios({
      url: BASE_URL + `site_returns/get_for_users`,
      method: "get",
    })
      .then((res) => {
        if (Array.isArray(res.result)) {
          setReturnPolicies(res.result);
        }
      })
      .finally(() => {});
  };
  const getCancelResons = () => {
    Axios({
      url: BASE_URL + `cancelorder/get_all`,
      method: "get",
    })
      .then((res) => {
        if (Array.isArray(res?.result)) {
          let reasons = [...res.result];
          setReasons(
            reasons?.map((item) => {
              return { ...item, checked: false };
            })
          );
        }
      })
      .finally(() => {});
  };
  useEffect(() => {
    getReturns();
    getCancelResons();
  }, []);
  const statuses = [
    {
      id: 1,
      label: "قيد الانتظار",
      englishLabel: "pending",
      value: "تم الطلب",
      englishValue: "Ordered",
      description_ar:
        "تم إنشاء الطلب وإرساله إلى قسم التحضيرات لمراجعة جميع التفاصيل.",
      description_en:
        "The request has been created and sent to the preparations department for review.",
    },
    {
      id: 4,
      label: "مكتملة",
      englishLabel: "completed",
      value: "تم تجهيز الطلب",
      englishValue: "Ready",
      description_ar: "تم إكمال الطلب بنجاح وتم تجهيز جميع المنتجات بشكل كامل.",
      description_en:
        "The request has been successfully completed with all products prepared.",
    },
    {
      id: 5,
      label: "قيد التوصيل",
      englishLabel: "in_delivery",
      value: "يتم الآن التوصيل",
      englishValue: "Out for delivery",
      description_ar: "الطلب الآن في مرحلة التوصيل وسيصل إلى وجهته قريبًا.",
      description_en:
        "The request is currently in delivery and will reach its destination soon.",
    },
    {
      id: 6,
      label: "تم التوصيل",
      englishLabel: "delivered",
      value: "تم التوصيل",
      englishValue: "Delivered",
      description_ar:
        "تم توصيل الطلب بنجاح إلى العنوان المحدد. نأمل أن تكون راضيًا عن الخدمة.",
      description_en:
        "The request has been successfully delivered to the specified address. We hope you are satisfied with the service.",
    },
    {
      id: 2,
      label: "ملغاة",
      englishLabel: "canceled",
      value: "ملغاة",
      englishValue: "Canceled",
      description_ar: "تم إلغاء الطلب بسبب وجود خطأ في الطلب أو مشكلة تقنية.",
      description_en:
        "The request has been canceled due to an error or technical issue.",
    },
    {
      id: 3,
      label: "مرفوضة",
      englishLabel: "rejected",
      value: "مرفوض",
      englishValue: "Rejected",
      description_ar:
        "تم رفض الطلب لأن بعض المنتجات غير متوفرة أو لعدم تلبية شروط الطلب.",
      description_en:
        "The request has been rejected due to unavailable products or failure to meet the requirements.",
    },
  ];

  const statusColors = {
    pending: "#f0ad4e", // yellow
    canceled: "#d9534f", // red
    rejected: "#d9534f", // red
    completed: "#5cb85c", // green
    in_delivery: "#5bc0de", // blue
    delivered: "#5cb85c", // green
  };
  const getStatusClass = (status) => {
    const currentIndex = statuses.findIndex(
      (s) => s.englishLabel?.toLowerCase() === orderData?.order_status
    );
    const statusIndex = statuses.findIndex(
      (s) => s.englishLabel?.toLowerCase() === status.englishLabel
    );
    return currentIndex > statusIndex
      ? "active greenColor"
      : currentIndex == statusIndex
      ? "active"
      : "";
  };
  return (
    <div className="order-right-container">
      <div className="pay-map-container">
        {statuses.map((status) => (
          <div
            key={status.id}
            className={
              language === "ar"
                ? `row ${getStatusClass(status)}`
                : `row rev_row ${getStatusClass(status)}`
            }
          >
            <div className="title">
              <h1
                className={getStatusClass(status)}
                style={{
                  color: getStatusClass(status)
                    ? statusColors[status.englishLabel]
                    : "black",
                }}
              >
                {language === "ar" ? status.value : status.englishValue}
              </h1>
            </div>
            <div className="">
              {language == "ar"
                ? status?.description_ar
                : status?.description_en}
            </div>
          </div>
        ))}
      </div>
      <div className="bottom">
        <Link onClick={() => setContactOpen(true)}>
          {language == "ar"
            ? "التواصل مع خدمة العملاء"
            : "Contact customer service"}
        </Link>
        <Link onClick={() => setReturnPolicyOpen(true)}>
          {language == "ar" ? "سياسة الاسترجاع" : "Return Policy"}
        </Link>
        {orderData?.order_status == "pending" && (
          <Link onClick={() => setCancelOrder(true)}>
            {language == "ar" ? "الغاء الطلب" : "Cancelling order"}
          </Link>
        )}
      </div>
      <div className="cancel-popup">
        <PopUp
          title={language == "ar" ? "الغاء الطلب" : "Cancel order"}
          open={cancelOrder}
          setOpen={setCancelOrder}
        >
          <h3>
            {language == "ar"
              ? "هل انت متاكد من الغاء الطلب؟"
              : "Are you sure you want to cancel the order?"}
          </h3>
          <div className="cancel_div">
            <h5>
              {language == "ar"
                ? "أسباب إلغاء طلبك"
                : "Reasons for canceling your order"}
            </h5>
            <div className="reasons">
              {reasons?.map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      setcancel_reson(
                        language == "ar" ? item.title_ar : item.title_en
                      );
                      setReasons(
                        reasons?.map((newItem) => {
                          return {
                            ...newItem,
                            checked: item.id == newItem.id ? true : false,
                          };
                        })
                      );
                    }}
                    className="reason"
                  >
                    <div
                      className={
                        item.checked ? "parent_checked act" : "parent_checked"
                      }
                    >
                      <div className="child_checked"></div>
                    </div>
                    <p>{language == "ar" ? item.title_ar : item.title_en}</p>
                  </div>
                );
              })}
            </div>
            <div className="comment">
              <textarea
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                name=""
                placeholder={
                  language == "ar"
                    ? "برجاء كتابة الأسباب إن وجدت لتحسين خدمتنا"
                    : "Please write reasons, if any, to improve our service"
                }
                id=""
                cols="30"
                rows="10"
              ></textarea>
            </div>
          </div>
          <div className="buttons-container">
            {cancleLoading ? (
              <Spinner />
            ) : (
              <button onClick={handleCancelOrder}>
                {language == "ar" ? "نعم" : "Yes"}
              </button>
            )}
            <button onClick={() => setCancelOrder(false)}>
              {language == "ar" ? "رجوع" : "return"}
            </button>
          </div>
        </PopUp>
      </div>
      <PopUp
        title={language == "ar" ? "سياسة الاسترجاع" : "Return Policy"}
        open={returnPolicyOpen}
        setOpen={setReturnPolicyOpen}
      >
        <div>
          {/* <h5>حالات الاسترجاع</h5> */}
          <ul className="return-policy-list">
            {console.log(returnPolicies)}
            {language == "en" ? (
              siteData?.return_poli_en && siteData?.return_poli_en?.length ? (
                <p
                  dangerouslySetInnerHTML={{ __html: siteData?.return_poli_en }}
                ></p>
              ) : null
            ) : siteData?.return_poli_ar && siteData?.return_poli_ar?.length ? (
              <p
                dangerouslySetInnerHTML={{ __html: siteData?.return_poli_ar }}
              ></p>
            ) : null}
          </ul>
        </div>
      </PopUp>
      <PopUp
        title={
          language == "ar"
            ? "التواصل مع خدمة العملاء"
            : "Contact customer service"
        }
        open={contactOpen}
        setOpen={setContactOpen}
      >
        <h3></h3>
        <div className="rowDiv">
          <IconWithText
            onClick={() => window.open("tel:" + siteData?.mobile, "_blanck")}
            icon={Phone}
            text={language == "ar" ? "الخط الساخن" : "Hot Line"}
            className={"contact"}
          />
        </div>
        <div className="rowDiv">
          <IconWithText
            onClick={() =>
              window.open("https://wa.me/" + siteData?.whats_number, "_blanck")
            }
            icon={whatsApp}
            text={language == "ar" ? "واتساب" : "WhatsApp"}
            className={"contact"}
          />
        </div>
      </PopUp>
    </div>
  );
};
